export const SET_DAYS = 'SET_DAYS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_BRANDS = 'SET_BRANDS'
export const SET_BRAND = 'SET_BRAND'
export const SET_PREFERENCES = 'SET_PREFERENCES'
export const RESET_PREFERENCES = 'RESET_PREFERENCES'
export const SET_PREFERENCE = 'SET_PREFERENCE'
export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE'
export const RESET_PREFERENCE_CHANGE = 'RESET_PREFERENCE_CHANGE'
export const SET_FRANCHISEES = 'SET_FRANCHISEES'
export const SET_SHOPS = 'SET_SHOPS'

export const BRANDS_ORDER_BY = 'brands/orderBy'
export const BRANDS_SORT_DIR = 'brands/sortDir'
export const BRANDS_DAYS = 'brands/days'
export const BRANDS_PAGE_SIZE = 'brands/pageSize'
export const BRANDS_SEARCH_TERM = 'brands/searchTerm'
export const BRANDS_FILTER_BY = 'brands/filterBy'



// WEBPACK FOOTER //
// ./src/store/modules/brands/types.js